import { render, staticRenderFns } from "./ProductOffersTable.vue?vue&type=template&id=64a9d013&scoped=true&"
import script from "./ProductOffersTable.vue?vue&type=script&lang=js&"
export * from "./ProductOffersTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductOffersTable.vue?vue&type=style&index=0&id=64a9d013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9d013",
  null
  
)

export default component.exports